import { motion } from 'framer-motion';
import { useGameStore } from '../stores/gameStore';
import { playClick } from '../utils/audio';

export const LevelSelect = () => {
  const { phase, currentLevel, startGame, goToMenu } = useGameStore();

  if (phase !== 'levelSelect') return null;

  const levels: Array<{ level: 1 | 2 | 3; name: string; speed: string }> = [
    { level: 1, name: 'Slow', speed: '200ms' },
    { level: 2, name: 'Normal', speed: '150ms' },
    { level: 3, name: 'Fast', speed: '100ms' }
  ];

  return (
    <div className="lcd-menu">
      <h2 className="nokia-title">SELECT LEVEL</h2>
      <div className="level-list">
        {levels.map((lvl) => (
          <motion.button
            key={lvl.level}
            className={`level-item ${currentLevel === lvl.level ? 'selected' : ''}`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              playClick();
              startGame(lvl.level);
            }}
          >
            <div className="level-name">Level {lvl.level} - {lvl.name}</div>
            <div className="level-speed">{lvl.speed}</div>
            {currentLevel === lvl.level && <div className="level-check">✓</div>}
          </motion.button>
        ))}
      </div>
      <motion.button
        className="back-btn"
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          playClick();
          goToMenu();
        }}
      >
        ← Back
      </motion.button>
    </div>
  );
};

export default LevelSelect;

